import script from "./OrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderView.vue?vue&type=script&setup=true&lang=js"

import "./OrderView.vue?vue&type=style&index=0&id=3777cb9c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3777cb9c"]])

export default __exports__